module.exports = __webpack_public_path__ + "static/media/login-4.8622bbfe.jpg";